<template>
  <div id="DocumentLimitTransactionTransferOfBondTerms" class="sun not-full">
    <div class="title">채권양도승낙서 및 위임장</div>
    <div class="content">
      <pre>(주)펀다 - 본인은 본 계약서에 의하여 귀사가 본인에대해서 가지고 있는 금전채권 및 계약상 본인에 대하여 갖는일체의 권리(계약해제권을 포함한 계약자로서 갖는 모 든 권리)(이하 ‘본건 대출’채권이라함)를 귀사가  &emsp;&emsp;&emsp;년  &emsp;&emsp;월  &emsp;&emsp;일&emsp;&emsp;(이하‘양수인’이라 함) &emsp;&emsp;&emsp;&emsp;에게 채권매각을 위하여 양도함에 아무런이의 없이 승낙합니다. 이와 관 련하여 본인은 귀사가 본인을대리하여 승낙할 수 있는 권한(위  양도관 련백지부분을 보충할 수있는 권한을 포함)을 위 임합니다. 단, 본건 대출채권의 이자 및원금은 양수인이 별도 서면청구에 기재된 방법에 따라 본건대출채권의 이자 및 원금은 양수인이 별도 서면 청구에 기재된방법에 따라 본건 대출채권의 이자 및 원금을 양수인에게 직접납입하도록 하겠습니다. 또한, 본인은 귀사가 본인으로부터 취득한 상기 개인신용정보를 채권의 양도에 따라 양수인으로부터채권 추심등의 업무를 위탁 받은자에게 제공되는 것에 대해서도이의 없이 동의합니다.
      </pre>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentLimitTransactionTransferOfBondTerms',
  data: function () {
    return {}
  },
  computed: {},
  created() {},
  destroyed() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
#DocumentLimitTransactionTransferOfBondTerms {
  padding-top: 25px;
  padding-bottom: 25px;
  background-color: #f4faff;
  .title {
    font-weight: 600;
    font-size: 16px;
  }
  .description {
    margin-top: 13px;
  }
  .content {
    font-size: 16px;
    line-height: 1.5;
    margin-top: 10px;
  }
  .indent {
    margin-left: 15px;
  }
}
</style>
